import { createSlice } from "@reduxjs/toolkit";
import {
  fetchCoinSettlements,
  addCoinSettlement,
  updateCoinSettlement,
  deleteCoinSettlement,
} from "./coinSettlementsThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const coinSettlementsSlice = createSlice({
  name: "coinSettlements",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCoinSettlements.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchCoinSettlements.fulfilled, (state, action) => {
      state.loading = false;
      state.items = action.payload || [];
    });
    builder.addCase(fetchCoinSettlements.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(addCoinSettlement.fulfilled, (state, action) => {
      state.items.push(action.payload);
    });
    builder.addCase(updateCoinSettlement.fulfilled, (state, action) => {
      const idx = state.items.findIndex(item => item.id === action.payload.id);
      if (idx !== -1) {
        state.items[idx] = action.payload;
      }
    });
    builder.addCase(deleteCoinSettlement.fulfilled, (state, action) => {
      state.items = state.items.filter(item => item.id !== action.payload);
    });
  },
});

export default coinSettlementsSlice.reducer;
